class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.menu = this.querySelector('ul');
    if(!this.menu) {
      throw new Error('No valid menu found.');
    }
    this.caretDown = this.querySelector('.caret-down');
    this.caretUp = this.querySelector('.caret-up');
    this.isOpen = false;
    this.querySelector('label').addEventListener('click', this.toggle.bind(this));
    this.addEventListener('blur', this.close.bind(this));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    const open = document.querySelectorAll('menu-drawer[data-state="open"]');
    open.forEach(i => {
      i.close();
    })
    this.menu.style.setProperty('left', 0);
    this.menu.style.removeProperty('right', 0);
    const rect = this.menu.getBoundingClientRect();
    if((window.innerWidth - rect.right) < 0) {
      this.menu.style.removeProperty('left');
      this.menu.style.setProperty('right', 0);
    }
    this.setAttribute('data-state', 'open');
    this.menu.style.visibility = 'visible';
    this.menu.style.opacity = 1;
    this.caretDown?.classList.add('hidden');
    this.caretUp?.classList.remove('hidden');
    this.isOpen = true;
    this.setFocus();
  }

  close(event = false) {
    if(event && this.contains(event.relatedTarget)) {
      return false;
    }
    this.setAttribute('data-state', 'closed');
    this.menu.style.visibility = 'hidden';
    this.menu.style.opacity = 0;
    this.caretDown?.classList.remove('hidden');
    this.caretUp?.classList.add('hidden');
    this.isOpen = false;
  }

  setFocus() {
    window.setTimeout(() => this.focus(), 100);
  }
}

customElements.define('menu-drawer', MenuDrawer);